import M from "../strings";
import _ from "underscore"
import * as datasource from "../utils/datasource";


export const TextFormat = {
    SIMPLE_TEXT: {
        value: 0,
        label: M("simpleText"),
    },
    ADVANCED_TEXT: {
        value: 1,
        label: M("advancedText"),
    },
    HTML: {
        value: 2,
        label: M("html"),
    },
};

export const TextFormatDatasource = datasource.fixed(
    _.map(TextFormat,f=>f)
);

export const PAGES = {
    DASHBOARD: "dashboard",
    EVALUATIONS: "survey",
    RETAILERS: "store",
    SETTINGS: "settings",
};

export const SURVEY_STATUS = {
    OPEN: "open",
    CLOSED: "closed",
};

export const RATING_TYPE = {
    ONE_TO_FIVE: "one_to_five",
    ONE_OR_FIVE: "one_or_five",
    TARGET: "target",
    TEXT: "text",
}

export const COMPUTATION_TYPES = {
    NOT_COMPUTED: "not-computed",
    SUM: "sum",
    AVG: "avg",
    MIN: "min",
    MAX: "max",
}
